import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-585ab5d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card lh-lg" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "mb-13" }
const _hoisted_5 = { class: "h1 text-dark mb-5" }
const _hoisted_6 = { class: "text-muted fw-semibold" }
const _hoisted_7 = {
  action: "",
  class: "form fv-plugins-bootstrap5 fv-plugins-framework",
  method: "post",
  id: "kt_contact_form"
}
const _hoisted_8 = { class: "row mb-5" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_12 = { class: "fw-semibold mb-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_14 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_15 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_16 = { class: "fw-semibold mb-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_18 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_19 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_20 = { class: "fw-semibold mb-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_22 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_23 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_24 = { class: "fw-semibold mb-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_26 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_27 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_28 = { class: "fw-semibold mb-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_30 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_31 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_32 = { class: "fw-semibold mb-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_34 = { class: "col-12 fv-row fv-plugins-icon-container" }
const _hoisted_35 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_36 = { class: "fw-semibold mb-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "d-flex flex-column mb-10 fv-row fv-plugins-icon-container" }
const _hoisted_40 = { class: "fs-6 fw-semibold mb-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "d-flex flex-column mb-10 fv-row fv-plugins-icon-container" }
const _hoisted_44 = { class: "fs-6 fw-semibold mb-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_46 = { class: "col-12" }
const _hoisted_47 = { class: "indicator-label" }
const _hoisted_48 = { class: "indicator-progress" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.translate("join us")), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.translate(
                "You can send a proxy request by completing the form below"
              )), 1)
        ]),
        _createElementVNode("form", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.translate("first name and last name")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "",
                    name: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.formData.name]
                  ]),
                  _hoisted_13
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate("phone number")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: "form-control",
                      placeholder: "",
                      name: "mobile",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.mobile) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formData.mobile]
                    ]),
                    _hoisted_17
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translate("Phone")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: "form-control",
                      placeholder: "",
                      name: "phone",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.phone) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formData.phone]
                    ]),
                    _hoisted_21
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.translate("National Code")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "",
                      name: "nationality_code",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.nationality_code) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formData.nationality_code]
                    ]),
                    _hoisted_25
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate("Your Career")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "",
                      name: "job",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.job) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formData.job]
                    ]),
                    _hoisted_29
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate(
                        "How many years of sales experience do you have?"
                      )), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "",
                      name: "salesHistory",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.sales_history) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formData.sales_history]
                    ]),
                    _hoisted_33
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.translate(
                        "How much time do you want to spend on Inboxino?"
                      )), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "",
                      name: "time_in_month",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.time_in_month) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formData.time_in_month]
                    ]),
                    _hoisted_37
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.translate("What facilities do you have for sale?")), 1),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control",
                      rows: "6",
                      name: "description",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.description) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formData.description]
                    ]),
                    _hoisted_41
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.translate("Why did you choose Inboxino?")), 1),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control",
                      rows: "6",
                      name: "whyUs",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.why_inboxino) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formData.why_inboxino]
                    ]),
                    _hoisted_45
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                      type: "button",
                      class: "btn btn-primary w-100",
                      id: "kt_contact_submit_button"
                    }, [
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.translate("Registration of representation request")), 1),
                      _createElementVNode("span", _hoisted_48, [
                        _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                        _hoisted_49
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}